import httpClientService from 'services/httpClientService'

const api = httpClientService()

export const loginUser = payload => api.post('/login', payload)
export const logoutUser = () => api.get('/logout')
